module.exports = __webpack_public_path__ + "static/media/logo.2366a999.svg";